export default class SessionStorage {
  static prefix: string = "QR_CUSTOMER_WEB_APP";

  private static getKey(key: string) {
    return `${SessionStorage.prefix}_${key.toUpperCase()}`;
  }

  static get(key: string, defaultValue: any = null) {
    return sessionStorage.getItem(SessionStorage.getKey(key)) ?? defaultValue;
  }

  static set(key: string, value: any) {
    sessionStorage.setItem(SessionStorage.getKey(key), value);
  }

  static remove(key: string) {
    sessionStorage.removeItem(SessionStorage.getKey(key));
  }

  static removeList(keys: string[]) {
    keys.forEach(this.remove);
  }

  static clear() {
    sessionStorage.clear();
  }
}
